'use strict';

// import "chosen-js";
import "./../lib/chosen-js/chosen.jquery";

(function($){

    function init(){
        $('.chosen-select').chosen({
            width: '100%',
            disable_search: true,
            placeholder_text_single: ' ',
            browser_is_supported: function(){
                return true;
            },
        });

        // $('.form-item input[type="text"], .form-item input[type="password"]').on({
        //     focus: function(){
        //         this.closest('.prfl-field').classList.remove('error');
        //         this.closest('.prfl-field').classList.add('focus');
        //     },
        //     blur: function(){
        //         this.closest('.prfl-field').classList.remove('focus');
        //     }
        // })
    }

    document.addEventListener('DOMContentLoaded', init);
}(jQuery));
